import { GriffelStyle, makeStyles, tokens } from '@fluentui/react-components';

const flexCenter: GriffelStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const useCircularIconStyles = makeStyles({
  iconWrapper: {
    ...flexCenter,
    borderRadius: tokens.borderRadiusCircular,
  },
  iconCenter: {
    ...flexCenter,
  },
});
